import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { NumberCounterState } from './types'

@safeCustomElement('mdc-number-counter')
export class MdcNumberCounter extends LitElement {
  @property({ type: String }) state: NumberCounterState = 'default'
  @property({ type: Number }) count = 0

  static styles = css`
		:host {
			display: inline-flex;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-number-counter {
			display: inline-flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			min-width: 1rem;
			min-height: 1rem;
			font-size: var(--text-062-and-half);
			font-weight: 450;
			line-height: 1.2;
			text-align: center;
			border-radius: var(--radius-full);
			box-sizing: border-box;
			padding: 0.25rem;
			aspect-ratio: 1 / 1;
		}

		.mdc-number-counter--state-default {
			color: var(--color-functional-gray-white);
			background-color: var(--color-functional-gray-black);
		}

		.mdc-number-counter--state-disabled {
			color: var(--color-functional-gray-300);
			background-color: var(--color-functional-gray-50);
		}
	`

  render() {
    const className = `mdc-number-counter mdc-number-counter--state-${this.state}`

    return html`<div class=${className}><span>${this.count}</span></div>`
  }
}
